import React, { useEffect, useState, useCallback } from "react";
import { historyApi } from "../services/api";
import "./Page.css";
import "./HistoryPage.css";

const STATUS_CONFIG = {
  running_low: { label: "Running Low", color: "#f59e0b", emoji: "🟡" },
  finished: { label: "Finished", color: "#ef4444", emoji: "🔴" },
};

export default function HistoryPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchHistory = useCallback(async () => {
    try {
      setLoading(true);
      const data = await historyApi.getHistory();
      setItems(data);
      setError(null);
    } catch {
      setError("Failed to load history.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchHistory(); }, [fetchHistory]);

  const handleClear = async () => {
    if (!window.confirm("Clear all purchase history?")) return;
    try {
      await historyApi.clearHistory();
      setItems([]);
    } catch {
      setError("Failed to clear history.");
    }
  };

  const groupByDate = (items) => {
    const groups = {};
    items.forEach((item) => {
      const date = new Date(item.purchased_at).toLocaleDateString("en-US", {
        weekday: "short", month: "short", day: "numeric"
      });
      if (!groups[date]) groups[date] = [];
      groups[date].push(item);
    });
    return groups;
  };

  const grouped = groupByDate(items);

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">📋 Purchase History</h1>
          <p className="page-sub">{items.length} purchase{items.length !== 1 ? "s" : ""} recorded</p>
        </div>
        {items.length > 0 && (
          <button className="btn-danger" onClick={handleClear}>
            🗑 Clear All
          </button>
        )}
      </div>

      {error && <div className="error-banner">{error}</div>}

      {loading ? (
        <div className="loading">Loading history…</div>
      ) : items.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📭</div>
          <p>No purchases recorded yet.</p>
          <p style={{fontSize: "13px", marginTop: "8px"}}>Mark cart items as purchased to see them here.</p>
        </div>
      ) : (
        <div className="history-list">
          {Object.entries(grouped).map(([date, dateItems]) => (
            <div key={date} className="history-group">
              <div className="history-date">{date}</div>
              {dateItems.map((item) => {
                const cfg = STATUS_CONFIG[item.status_snapshot] || {};
                return (
                  <div key={item.id} className="history-row">
                    <div className="history-item-info">
                      <div className="history-item-top">
                        <span className="history-item-name">{item.item_name}</span>
                        {item.quantity > 1 && (
                          <span className="cart-qty">×{item.quantity}</span>
                        )}
                      </div>
                      <div className="history-item-meta">
                        {item.category && <span className="history-cat">{item.category}</span>}
                        <span style={{ color: cfg.color }}>
                          {cfg.emoji} {cfg.label}
                        </span>
                      </div>
                    </div>
                    <span className="history-time">
                      {new Date(item.purchased_at).toLocaleTimeString("en-US", {
                        hour: "2-digit", minute: "2-digit"
                      })}
                    </span>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
